/* unplugin-vue-components disabled */import { render } from "./xEdtiorLayout.vue?vue&type=template&id=43f05fce&scoped=true"
import script from "./xEdtiorLayout.vue?vue&type=script&lang=js"
export * from "./xEdtiorLayout.vue?vue&type=script&lang=js"

import "./xEdtiorLayout.vue?vue&type=style&index=0&id=43f05fce&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43f05fce"]])

export default __exports__